import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class InssService {
  constructor(private http: HttpClient) {}

  getInssData(formsId: number): Observable<any> {
    return this.http.get(`${environment.api_guia}forms/${formsId}/inss`);
  }

  updateInssData(
    formsId: number,
    inssId: number,
    data: any
  ): Observable<any> {
    return this.http.patch(
      `${environment.api_guia}forms/${formsId}/inss/${inssId}`,
      data
    );
  }
}
